import type { CalendarEvent } from '../types'

// Badge background / text colors per audience. Presentation only — the event
// content itself comes from the CMS.
export const AUDIENCE_BADGE: Record<CalendarEvent['audience'], { bg: string; fg: string; label: string }> = {
  jovenes: { bg: '#1b4f9c', fg: '#fff', label: 'Jóvenes' },
  hombres: { bg: '#15233f', fg: '#fff', label: 'Hombres' },
  mujeres: { bg: '#c1272d', fg: '#fff', label: 'Mujeres' },
  especial: { bg: '#d4a017', fg: '#15233f', label: 'Especial' },
  familia: { bg: '#1b4f9c', fg: '#fff', label: 'Familia' },
}
